
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SearchLocationComponent } from './search-location.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SearchLocationComponent],
  imports: [NgSelectModule, FormsModule],
  exports: [SearchLocationComponent],
})
export class SearchLocationModule {}
